import { useState } from "react";
import { Modal, DatePicker } from "antd";
import { useDispatch } from "react-redux";
import { startGetReasignacionesXls } from "../../context/actions/reportesActions";

const { RangePicker } = DatePicker;

export const ModalReasignacionesXls = ({ visible, onClose }) => {
  const dispatch = useDispatch();
  const [fechas, setFechas] = useState(null);
  const [fechaAncla, setFechaAncla] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleOk = async () => {
    setLoading(true);
    const result = await dispatch(startGetReasignacionesXls({
      fechaInicio: fechas[0].format("YYYY-MM-DD"),
      fechaFin: fechas[1].format("YYYY-MM-DD"),
    }));
    setLoading(false);
    if (result.code === 0) {
      setFechas(null);
      setFechaAncla(null);
      onClose();
    }
  };

  const handleCancel = () => {
    setFechas(null);
    setFechaAncla(null);
    onClose();
  };

  const handleCalendarChange = (dates) => {
    if (dates?.[0] && !dates?.[1]) setFechaAncla(dates[0]);
    if (dates?.[1] && !dates?.[0]) setFechaAncla(dates[1]);
  };

  const disabledDate = (current) => {
    if (!fechaAncla) return false;
    return Math.abs(current.diff(fechaAncla, "day")) > 31;
  };

  return (
    <Modal
      title="Historial de Reasignación"
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={loading}
      okButtonProps={{ disabled: !fechas }}
    >
      <RangePicker
        value={fechas}
        style={{ width: "100%" }}
        onChange={(dates) => setFechas(dates)}
        onCalendarChange={handleCalendarChange}
        disabledDate={disabledDate}
      />
    </Modal>
  );
};
